/** @jsxImportSource @emotion/react */
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { PERIODOS } from "./periodos";

const estiloCampo = {
  display: "flex",
  flexDirection: "column",
  gap: "0.5em",
  minWidth: "12rem",
  flex: "1 1 12rem"
};

const estiloEtiqueta = { fontWeight: "bold" };

function Campo({ etiqueta, children }) {
  return (
    <div css={estiloCampo}>
      <label css={estiloEtiqueta}>{etiqueta}</label>
      {children}
    </div>
  );
}

/**
 * Barra de filtros del panel. Es controlada: el estado vive en la pantalla y
 * acá solo se muestra y se avisa cada cambio con `onCambio(clave, valor)`.
 */
export default function FiltrosIndicadores({
  filtros,
  onCambio,
  monedas,
  clientes,
  certificadoTipos
}) {
  return (
    <Card css={{ marginBottom: "1em" }}>
      <div css={{ display: "flex", flexWrap: "wrap", gap: "1em", alignItems: "flex-end" }}>
        <Campo etiqueta="Período">
          <Dropdown
            value={filtros.periodo}
            options={PERIODOS}
            onChange={(e) => onCambio("periodo", e.value)}
          />
        </Campo>

        {filtros.periodo === "personalizado" && (
          <>
            <Campo etiqueta="Desde">
              <InputText
                type="date"
                value={filtros.desde || ""}
                max={filtros.hasta || undefined}
                onChange={(e) => onCambio("desde", e.target.value || null)}
              />
            </Campo>
            <Campo etiqueta="Hasta">
              <InputText
                type="date"
                value={filtros.hasta || ""}
                min={filtros.desde || undefined}
                onChange={(e) => onCambio("hasta", e.target.value || null)}
              />
            </Campo>
          </>
        )}

        <Campo etiqueta="Moneda">
          <Dropdown
            value={filtros.monedaId}
            options={monedas}
            optionLabel="nombre"
            optionValue="id"
            onChange={(e) => onCambio("monedaId", e.value)}
          />
        </Campo>

        <Campo etiqueta="Cliente">
          <Dropdown
            value={filtros.clienteId}
            options={clientes}
            optionLabel="nombre"
            optionValue="id"
            onChange={(e) => onCambio("clienteId", e.value ?? null)}
            placeholder="Todos"
            showClear
            filter
          />
        </Campo>

        <Campo etiqueta="Tipo de certificado">
          <Dropdown
            value={filtros.certificadoTipoId}
            options={certificadoTipos}
            optionLabel="nombre"
            optionValue="id"
            onChange={(e) => onCambio("certificadoTipoId", e.value ?? null)}
            placeholder="Todos"
            showClear
            filter
          />
        </Campo>

        <div
          css={{
            display: "flex",
            alignItems: "center",
            gap: "0.5em",
            paddingBottom: "0.6em"
          }}
        >
          <InputSwitch
            inputId="indicadores-con-iva"
            checked={filtros.mostrarConIva}
            onChange={(e) => onCambio("mostrarConIva", e.value)}
          />
          <label htmlFor="indicadores-con-iva" css={estiloEtiqueta}>
            Con IVA
          </label>
        </div>
      </div>
    </Card>
  );
}
